import { inject, Pipe, PipeTransform } from '@angular/core';
import { Environment } from '../rmaProperties';

@Pipe({
  name: 'rmaSupportUrl',
  standalone: true,
})
export class RmaSupportUrlPipe implements PipeTransform {
  private readonly environment = inject(Environment);

  public transform(value: string): string {
    return new URL(value, this.environment.supportUrl).toString();
  }
}
